import React, { useState,useContext, useEffect } from 'react';
import DynamicIcon from '../../components/dynamicicon';
import JisButton from '../../components/controls/jisButton';
import JisCheckbox from '../../components/controls/jisCheckbox';
import { ShareContext } from '../../context/ShareContext'
import * as Constants from '../../constants';
import * as Services from '../../services';
import JisTabButton from '../../components/controls/jisTabButton';
import BackLoader from '../../components/backloader';
import JisDialog from '../../components/dialog';
import JisDialogForm from '../../components/formdialog';

function VacationSetup() {
  
    const {activePage, token, setIsExpired,setAlert,frequentData} = useContext(ShareContext);
      const [page, setPage] = useState(null);
      const [tab, setTab] =useState('vacations');
    
      const [vacations, setVacations] = useState([]);
      const [vacation, setVacation] = useState({id:0});
      const [vacationMappings, setVacationMappings]= useState([]);
      const [vacationMapping, setVacationMapping] = useState({id:0});
      const [vacationId, setVacationId] = useState(0);
      const [loading, setLoading] = useState(false);
      const [isDialog, setIsDialog] = useState(false);
      const [err, setErr] = useState('');
      const [roles, setRoles] = useState([]);
      const [judges, setJudges] =useState([]);
    const [assignTo,setAssignTo]=useState(null);
    const [roleId, setRoleId] = useState(null);
    const [selectedJudges, setSelectedJudges]=useState({});
    const [selectedIds, setSelectedIds] = useState(new Set());

      useEffect(() => {    
        onLoadRoles();       
        onLoadVacations();
        onLoadJudges();
      
      }, []);

     useEffect(() => {  
        if(vacationId>0){
            onLoadVacationMappings();
        }         

      }, [vacationId]);

      useEffect(() => {  
        if(tab=='mapping'){
            if(vacationId==0){
                if(vacations.length>0){
                    setVacationId(vacations[0].id);
                }
            }
        }       

      }, [tab]);

       useEffect(() => {
                
                if(!(roleId==null || roleId==''))
               {
                setAssignTo(null);
                setJudges([]);
                 onLoadUserByRole();
               }
               
      
          }, [ roleId]);



      const onVacationChange = (e) => {
            setVacation({...vacation, [e.target.name]: e.target.value})   
        }
      const onVacationMappingChange = (e) => {
            setVacationMapping({...vacationMapping, [e.target.name]: e.target.value})   
        }
        
     const onLoadVacations= async()=>{
              //for account registration
              try {
                setLoading(true);
                  const resp = await fetch(`${Constants.apiUrl}/setup/vacation-setting/vacations`, { 
                    method: 'GET',
                    headers: {
                      'Content-Type': 'application/json',
                      'Authorization': `Bearer ${token}`,
                    },
                  });
                  
                  const data = await resp.json();
                  setLoading(false);
                 setVacations(data.list);
                 
                } catch (error) {
                  setLoading(false);
                  console.error(error);
                  
                }
          }  
     const onLoadVacationMappings= async()=>{
              //for account registration
              try {
                setLoading(true);
                  const resp = await fetch(`${Constants.apiUrl}/setup/vacation-setting/vacation-judge-mappings/${vacationId}`, { 
                    method: 'GET',
                    headers: {
                      'Content-Type': 'application/json',
                      'Authorization': `Bearer ${token}`,
                    },
                  });
                  
                  const data = await resp.json();
                  setLoading(false);
                 setVacationMappings(data.list);
                 
                } catch (error) {
                  setLoading(false);
                  console.error(error);
                }
        } 
     const onAdd=()=>{
        setIsDialog(true);
     }  
      const onDefault=(id)=>{
        setErr('');
          setIsDialog(false);
        if(tab=='vacations'){
            onLoadVacations();
            setVacation({id:0})
        } 
       else if(tab=='mapping'){
            onLoadVacationMappings()
            setVacationMapping({id:0})
            setAssignTo(null);
        }
       
    }

    const onEdit=(obj,index)=>{
        setErr('');
          setIsDialog(true);
        if(tab=='vacations'){
            
            setVacation(obj)
        } 
       else if(tab=='mapping'){
          
            setVacationMapping(obj)
        }
      
     }
      const onSave=async(e)=>{
             e.preventDefault();
            var path='';
            var obj=null;
            if(tab=='vacations' ){
                 path='/setup/vacation-setting/vacation';
                 obj={...vacation};
             }
              else if(tab=='mapping'){
                 path='/setup/vacation-setting/vacation-judge-mapping';
                 
                 const jids = Array.from(selectedIds, id => ({ judgeId: id, divisionId: 0 }));

                 if(jids.length==0){
                    setAlert({open:true, icon:'warning', title:'Selection',subtitle:'Please select the judge'});
                    return;
                }
            
                obj={...vacationMapping, vacationId,judgeDivisions:jids, };
             }
             
     
         setLoading(true)
        try {
        
        const url=`${Constants.apiUrl}${path}`;
        const resp = await fetch(url, {
            method: 'POST',
            body:JSON.stringify(obj) ,
            headers: {
            'Content-Type': 'application/json, text/plain',
            Authorization: `Bearer ${token}`,
            },
        });
        
        const data = await resp.json();
        setLoading(false);
        if(data.code==0){
            setAlert({open:true, title:'Vacation Setting',subtitle:'Vacation Settings saved successfully'})
                onDefault(data.id);
        }
        else if(data.code==-10){
                setIsExpired(true);
            }else{
            setErr(data.status);
            }
        //   setFlow({pos:6,code:"congrat"})
        
        
        } catch (error) {
        setLoading(false);
        console.error(error);
        
        // onMove();
        }
         }

         const onClose=()=>{
        setIsDialog(false);
        setVacation({id:0})
        setVacationMapping({id:0});
      


    }

    const onLoadRoles= async()=>{
                //for account registration
            try {
    
                setLoading(true);
                const resp = await fetch(`${Constants.apiUrl}/profile/getrolesBySearch/judge`, { 
                    method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': `Bearer ${token}`,}, });  
                const data = await resp.json();
                setLoading(false);
                if(data.code==0){
                    //ready
                    // fee, feelines, cinfo , parties 
                  setRoles(data.roles)
                   
                  
                } else if(data.code==-10){
                          setIsExpired(true);
                      }
                
                } catch (error) {
                setLoading(false);
                console.error(error);   
                }
            }
    
            const onLoadUserByRole= async()=>{
                //for account registration
            try {
    
                setLoading(true);
                const resp = await fetch(`${Constants.apiUrl}/profile/getUsersByRole/${roleId}/0`, { 
                    method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': `Bearer ${token}`,}, });  
                const data = await resp.json();
                setLoading(false);
                if(data.code==0){
                    //ready
                    // fee, feelines, cinfo , parties 
                  setJudges(data.pros)
                   
                  
                } else if(data.code==-10){
                          setIsExpired(true);
                      }
                
                } catch (error) {
                setLoading(false);
                console.error(error);   
                }
            }
            const onLoadJudges= async()=>{
                //for account registration
            try {
    
                setLoading(true);
                const resp = await fetch(`${Constants.apiUrl}/profile/getjudges/0`, { 
                    method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': `Bearer ${token}`,}, });  
                const data = await resp.json();
                setLoading(false);
                if(data.code==0){
                    //ready
                    // fee, feelines, cinfo , parties 
                  setJudges(data.list)
                   
                  
                } else if(data.code==-10){
                          setIsExpired(true);
                      }
                
                } catch (error) {
                setLoading(false);
                console.error(error);   
                }
            }

    const onSelectJudges =(opt)=>{
      setAssignTo(opt.id)
     // selectedJudges[opt.id] = {judgeId:opt.id}

      var _ids=new Set(selectedIds);
      if(_ids.has(opt.id)){
        _ids.delete(opt.id);
      }else{
        _ids.add(opt.id)
      }

      console.log(_ids);
      setSelectedIds(new Set(_ids));
    }

  return (
    <div>
     <div className='tab_body'>
        <div className='tab_section'  style={{ display: 'flex', gap: '20px', marginBottom: '20px' }}>
            <JisTabButton code="vacations" isActive={tab=='vacations'}  title="Vacations" data={page} isRoleBased={false} onClick={()=> setTab('vacations')}/>
          <JisTabButton code="mapping" isActive={tab=='mapping'}  title="Vacation Judge Mapping" data={page} isRoleBased={false}  onClick={()=> setTab('mapping')}/>
        </div>
   {tab=='vacations' && <div className='tab_view'>
            <div style={{textAlign:'right'}}> <JisButton variant='plain' onClick={onAdd}>Add Vacation</JisButton></div>
            <div className='table'>
            <div class="section-cases">
                <span>Vacations</span><span className='total'>{vacations?.length}</span>
            </div>
            <table className="case-table">
                <thead>
                    <tr>
                        <th>SN</th>
                        <th>Start</th>
                        <th>End</th>
                        <th>Status</th>
                        <th>Created by</th>
                        <th>CreatedOn</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                   { vacations.map((g, i) => { return (
                    <tr>
                        <td>{i+1}</td>
                        <td>{g.startDate}</td>
                        <td>{g.endDate}</td>
                       
                        <td>{g.isActive?'Active':'Inactive'}</td>
                       <td>{g.createdBy}</td>
                       <td>{g.createdOn}</td>
                        <td><JisButton variant='plain' onClick={()=>onEdit(g,i)}>Edit</JisButton></td>
                    </tr>
                   )} )}
                </tbody>
            </table>
        </div>
        </div>} 

       {tab=='mapping' && <div className='tab_view'>
            <div style={{textAlign:'right'}}> {vacationId>0 && <JisButton variant='plain' onClick={onAdd}>Add Vacation Mapping</JisButton>} </div>
           <div style={{display:'flex'}}>
             <div style={{flex:1}}>
                {vacations?.map((opt) => (
                    <div key={opt.id} className={`selected ${vacationId==opt.id?'active':''}`} onClick={()=>setVacationId(opt.id)}>
                       Vacation: {opt.startDate} - {opt.endDate}<br/>
                        <span>{opt.isActive?'Active':'Inactive'}</span>
                    </div>
                    ))} 
             </div>
             <div style={{flex:3}}>
                <div className='table'>
                            <div class="section-cases">
                                <span>Vacation Judge Mapping</span><span className='total'>{vacationMappings?.length}</span>
                            </div>
                            <table className="case-table">
                                <thead>
                                    <tr>
                                        <th>SN</th>
                                        <th>Judge</th>
                                        <th>Filing Type</th>
                                        <th>Start</th>
                                        <th>End</th>
                                        {/* <th>Division</th> */}
                                        <th>Status</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                { vacationMappings.map((g, i) => { return (
                                    <tr>
                                        <td>{i+1}</td>
                                        <td> {g.judge.suffix} {g.judge.firstName} {g.judge.lastName}</td>
                                        <td>{g.filingTypeId==null?'All': Constants.getItemById(frequentData?.filingtypes,g.filingTypeId)?.title}</td>
                                        <td>{g.startDate}</td>
                                        <td>{g.endDate}</td>
                                     {/*    <td> {Constants.getItemById(frequentData?.divisions,g.divisionId)?.title}</td> */}
                                        <td>{g.isActive?'Active':'Inactive'}</td>
                                        <td><JisButton variant='plain' onClick={()=>onEdit(g,i)}>Edit</JisButton></td>
                                    </tr>
                                )} )}
                                </tbody>
                            </table>
                        </div>
             </div>
           </div>
            
        </div>} 
       
     </div>
     <BackLoader open={loading} />
      {tab=='vacations' && isDialog && <JisDialogForm title="Vacation" onClose={onClose}>
        <form onSubmit={onSave}>
            <div  className="input-group">
                <label> Start Date</label>
                <div className='input-wrapper'>
                    <DynamicIcon iname="user" />
                  <input placeholder='Start Date' type='date' name="startDate" value={vacation.startDate}
                    onChange={onVacationChange}
                    required={true}
                  />
                </div>
                </div>
        <div  className="input-group">
                <label> End Date</label>
                <div className='input-wrapper'>
                    <DynamicIcon iname="user" />
                  <input placeholder='End Date' type='date' name="endDate" value={vacation.endDate}
                    onChange={onVacationChange}
                    required={true}
                  />
                </div>
                </div>        
                
                
               <JisCheckbox value={vacation.isActive} label="Active" onChange={(e)=>setVacation({...vacation,isActive:e})} />       
        <div>
            <JisButton type="submit">{vacation.id==0?'Save':'Update'}</JisButton>
        </div>
        </form>
     </JisDialogForm>}
     {tab=='mapping' && isDialog && <JisDialogForm title="Vacation Judge Mapping" onClose={onClose}>
        <form onSubmit={onSave}>
            <div className="select-group">
                <label>
                    Role:  
                </label>
                <select name="roleId" value={roleId}  onChange={(e)=>setRoleId(e.target.value)} required>
                    <option value="">Select Role </option>
                    {roles?.map((opt) => (
                    <option key={opt.id} value={opt.id}>
                        {opt.name}
                    </option>
                    ))}
                </select>
                
            </div>
            <div className="select-group">
                <label>
                    Judges: <strong style={{fontSize:12}}>(Please select one of the Judges) </strong>
                </label>
                <div className='content-box' style={{maxHeight:300}}>
                    {judges?.map((opt) => (
                    <div key={opt.id}  onClick={()=>onSelectJudges(opt)} className={`selected ${selectedIds.has(opt.id) ?'active':''}`}>
          <div style={{display:'flex'}}>
            <div>{opt.suffix} {opt.firstName} {opt.lastName}</div>
          {/* <div style={{flex:1}}><div className="select-group">
                <select name="divisionId" value={vacationMapping.divisionId}  onChange={onVacationMappingChange} >
                    <option value=''>Select Division</option>
                    {frequentData?.divisions.map((opt) => (
                    <option key={opt.id} value={opt.id}>
                        {opt.title}
                    </option>
                    ))}
                </select>
                </div></div> */}
</div>

                        
                    </div>
                    ))}
                </div>
                
            </div>
<div style={{display:'flex'}}>
     <div  className="input-group">
                <label> Start Date</label>
                <div className='input-wrapper'>
                    <DynamicIcon iname="user" />
                  <input placeholder='Start Date' type='date' name="startDate" value={vacationMapping.startDate}
                    onChange={onVacationMappingChange}
                    required={true}
                  />
                </div>
                </div>
        <div  className="input-group">
                <label> End Date</label>
                <div className='input-wrapper'>
                    <DynamicIcon iname="user" />
                  <input placeholder='End Date' type='date' name="endDate" value={vacationMapping.endDate}
                    onChange={onVacationMappingChange}
                    required={true}
                  />
                </div>
                </div> 
</div>
                  
                {/* <div className="select-group">
                <label> Division <span className="required">*</span> </label>
                <select name="divisionId" required value={vacationMapping.divisionId}  onChange={onVacationMappingChange} >
                    <option value=''>Select Division</option>
                    {frequentData?.divisions.map((opt) => (
                    <option key={opt.id} value={opt.id}>
                        {opt.title}
                    </option>
                    ))}
                </select>
                </div> */}
                <div className="select-group">
                <label> Filing Type <span className="required">*</span> </label>
                <select name="filingTypeId" value={vacationMapping.filingTypeId}  onChange={onVacationMappingChange} >
                    <option >All Filing Type</option>
                    {frequentData?.filingtypes?.map((opt) => (
                    <option key={opt.id} value={opt.id}>
                        {opt.title}
                    </option>
                    ))}
                </select>
                </div>
               <JisCheckbox value={vacationMapping.isActive} label="Active" onChange={(e)=>setVacationMapping({...vacationMapping,isActive:e})} />       
        <div>
            <JisButton type="submit">{vacationMapping.id==0?'Save':'Update'}</JisButton>
        </div>
        </form>
     </JisDialogForm>}     
    </div>
  );
}

export default VacationSetup;